import {useGtm} from "@gtm-support/vue-gtm";

interface PromotionData {
	creative_name: string;
	creative_slot: string;
	promotion_id: string;
	promotion_name: string;
	source_url?: string;
	target_url?: string;
}

export function usePromotion() {
	const gtm = useGtm();

	const addPromotionClick = (promo: PromotionData): void => {
		gtm?.trackEvent({
			event: "view_promotion",
			_clear: true,
			ecommerce: {
				...promo,
			},
		});
	};

	return {
		addPromotionClick,
	};
}
